import { APIFactory } from '../../ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from '../../ui-toolkit/rest/axiosErrorHandler';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';
import { convertFromIQueryResponseToIPageData, IPageData } from 'types/rest/IPageData';
import { DateTime } from 'luxon';
import { IEscrowJournalEntryData } from '../../types/accounting/data/IEscrowJournalEntryData';
import {
  IEscrowJournalEntriesResponse,
  IEscrowJournalEntryResponse,
} from '../../types/accounting/response/IEscrowJournalEntryResponse';
import { convertFromIPaginationQueryToIPaginationQueryRequest } from '../../types/rest/IPaginationQueryRequest';
import { convertFromISortQueryToISortQueryRequest } from '../../types/rest/ISortQueryRequest';
import { IEscrowJournalEntryRevisionQuery } from '../../types/accounting/query/IEscrowJournalEntryRevisionQuery';

const convertToApiQuery = ({
  amountCents,
  completedAtDate,
  createdAt,
  entryType,
  initiatedAtDate,
  note,
  paymentMethod,
  revisionType,
  ...rest
}: IEscrowJournalEntryRevisionQuery) => ({
  amountCents,
  entryType,
  note,
  paymentMethod,
  revisionType,
  createdAtStart: createdAt && DateTime.fromISO(createdAt[0]).toISO(),
  createdAtEnd: createdAt && createdAt[1] && DateTime.fromISO(createdAt[1]).toISO(),
  initiatedAtDateStart: initiatedAtDate && initiatedAtDate[0],
  initiatedAtDateEnd: initiatedAtDate && initiatedAtDate[1],
  completedAtDateStart: completedAtDate && completedAtDate[0],
  completedAtDateEnd: completedAtDate && completedAtDate[1],
  ...convertFromIPaginationQueryToIPaginationQueryRequest(rest),
  ...convertFromISortQueryToISortQueryRequest(rest),
});

//FYI: please preserve this boilerplate to enforce consistency if journal entries needs custom de-serialization
const convertResponseToData = (response: IEscrowJournalEntryResponse): IEscrowJournalEntryData => ({
  ...response,
});

export const getJournalEntryRevisionsAsync = async (
  query: IEscrowJournalEntryRevisionQuery
): Promise<IPageData<IEscrowJournalEntryData>> =>
  APIFactory(baseUrlService.ApiLocation)
    .get<IEscrowJournalEntriesResponse>(`/timber/api/internal/escrow/journal_entry_logs`, {
      params: convertToApiQuery(query),
    })
    .then((response) => convertFromIQueryResponseToIPageData(response.data, convertResponseToData))
    .catch(axiosErrorHandler);
